import { _routes } from "./routes"

const { ICONS } = require("@ohif/ui")

const storedUserId = sessionStorage.getItem('userId') || localStorage.getItem('userId');

export const permissionState =
{
  superadmin: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "hospital-side-menu",
        redirectTo: '/hospital',
        routeName: 'Clinics / Hospitals'
      },
      // {
      //   iconName: 'hospital-side-menu',
      //   redirectTo: '/teleradiology',
      //   routeName: 'Teleradiology Customers'
      // },
      {
        iconName: "user-side-menu",
        redirectTo: "/users",
        routeName: 'Users'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: 'indicator-icon',
        redirectTo: '/qualityIndicators',
        routeName: 'MIS Reports'
      },
      {
        iconName: 'audit-trail-side-menu',
        redirectTo: _routes.audit.teleradiologist,
        routeName: 'Teleradiology Audit Logs'
      },
      {
        iconName: 'audit-trail-side-menu',
        redirectTo: _routes.audit.teleradiologistPayouts,
        routeName: 'Tele User Payouts'
      },
      {
        iconName: "user-side-menu",
        redirectTo: '/myprofile',
        routeName: 'My Profile'
      },
      {
        iconName: "setting-side-menu",
        routeName: 'Settings',
          redirectTo:"/setting",
        subMenu: [
          { routeName: 'Case Timing', redirectTo: _routes.settings.caseTiming },
          { routeName: 'Tele Hospital Credits', redirectTo: _routes.settings.modalityPrice },
          { routeName: 'Tele Service Price', redirectTo: _routes.settings.teleServicePrice },
          { routeName: 'Plan Pricing', redirectTo: _routes.settings.pricing },
        ]
      }
    ]
  },
  hospitalsuperadmin: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: 'graph-icon',
        redirectTo: '/analytics',
        routeName: 'Analytics'
      },
      {
        iconName: 'indicator-icon',
        redirectTo: '/qualityIndicators',
        routeName: 'MIS Indicators'
      },
      {
        iconName: "user-side-menu",
        redirectTo: "/users",
        routeName: 'Users'
      }, {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/invoice",
        routeName: 'Billing Invoice'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/discountNotification",
        routeName: 'Discount Requests'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: '/edithospital',
        routeName: 'Clinic / Hospital Profile'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/audit",
        routeName: 'Audit Trails'
      },
      {
        iconName: "setting-side-menu",
        routeName: 'Settings',
          redirectTo:"/setting",
        subMenu: [
          { routeName: 'Report & Receipt Template', redirectTo: _routes.settings.reports },
          { routeName: 'Machines', redirectTo: '/machines' },
          { routeName: 'Active Machine', redirectTo: '/frontdeskmachine' },
          { routeName: 'PACS', redirectTo: '/pacs' },
          { routeName: 'Case Timing', redirectTo: _routes.settings.caseTiming },
          { routeName: 'General Settings', redirectTo: "/billing" },
        ]
      }
    ]
  },
  teraradiologysuperadmin: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "user-side-menu",
        redirectTo: "/teleradiologist",
        routeName: 'Users'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/invoice",
        routeName: 'Billing Invoice'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: '/editTeleradiology',
        routeName: 'Teleradiology Profile'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/audit",
        routeName: 'Audit Trails'
      },
      {
        iconName: "setting-side-menu",
        routeName: 'Settings',
          redirectTo:"/setting",
        subMenu: [
          { routeName: 'Report & Receipt Template', redirectTo: _routes.settings.reports },
          { routeName: 'Machines', redirectTo: '/machines' },
          { routeName: 'Active Machine', redirectTo: '/frontdeskmachine' },
          { routeName: 'PACS', redirectTo: '/pacs' },
          { routeName: 'General Settings', redirectTo: "/billing" },
        ]
      }
    ]
  },
  admin: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      }, {
        iconName: "user-side-menu",
        redirectTo: "/users",
        routeName: 'Users'
      }, {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/analytics",
        routeName: 'Analytics'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/invoice",
        routeName: 'Billing Invoice'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/discountNotification",
        routeName: 'Discount Requests'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/audit",
        routeName: 'Audit Trails'
      },
      {
        iconName: "setting-side-menu",
        routeName: 'Settings',
          redirectTo:"/setting",
        subMenu: [
          { routeName: 'Reports', redirectTo: _routes.settings.reports },
          { routeName: 'Machines', redirectTo: '/machines' },
          { routeName: 'Active Machine', redirectTo: '/frontdeskmachine' },
          { routeName: 'PACS', redirectTo: '/pacs' },
          { routeName: 'Case Timing', redirectTo: _routes.settings.caseTiming },
          { routeName: 'General Settings', redirectTo: "/billing" },
        ]
      }
    ]
  },
  frontdesk: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "user-side-menu",
        redirectTo: "/users",
        routeName: 'Users'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/invoice",
        routeName: 'Billing Invoice'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/discountNotification",
        routeName: 'Discount Requests'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
    nurse:{
      navLink:[
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
        },  {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      }, {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      }, {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      }, {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      }, {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
    radiologist:{
      navLink:[
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/analytics",
        routeName: 'Analytics'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Study List'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
            iconName:'report-side-menu',
            redirectTo:"/myworklist",
            routeName:"My Worklist"
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      }, {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
      ,
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/audit",
        routeName: 'Audit Trails'
      }

    ]
  },
    teleradiologistUser:{
      navLink:[

      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
            iconName:'report-side-menu',
            redirectTo:"/myworklist",
            routeName:"My Worklist"
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),

        routeName: 'My Profile'
      }


    ]
  },
    resident:{
      navLink:[

      {
            iconName:"dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
          },{
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      }, {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
      ,
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/audit",
        routeName: 'Audit Trails'
      }

    ]
  },
    clinician:{
      navLink:[
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      }, {
        iconName: "user-side-menu",
        redirectTo: "/users",
        routeName: 'Users'
      }, {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
        },{
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/audit",
        routeName: 'Audit Trails'
      }
    ]
  },
  technician: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
  technicianradiology: {
    navLink: [
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Study List'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
  pathologist: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: 'graph-icon',
        redirectTo: '/analytics',
        routeName: 'Analytics'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/templatelist",
        routeName: 'Create Template'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
          iconName:'report-side-menu',
          redirectTo:"/myworklist",
          routeName:"My Worklist"
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
  telepathologist: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/templatelist",
        routeName: 'Create Template'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
          iconName:'report-side-menu',
          redirectTo:"/myworklist",
          routeName:"My Worklist"
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
  pathologistAdmin: {
    navLink: [
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "lab-study-icon",
        redirectTo: "/lab-studies",
        routeName: 'Lab Studies'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/templatelist",
        routeName: 'Create Template'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      }
    ]
  },
  radiologistAdmin: {
        navLink:[

      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "studies-side-menu",
        redirectTo: "/",
        routeName: 'Studies'
      },
      {
        iconName: 'study-research-side-menu',
        redirectTo: '/studyresearch',
        routeName: 'Study Research'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "report-side-menu",
        redirectTo: '/rollbacklist',
        routeName: 'Rollback Reports'
      },
      {
        iconName: "dashboard-side-menu",
        redirectTo: '/templatelist',
        routeName: 'Create Template'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      },
    ]
  },
  government: {
        navLink:[
      {
        iconName: "dashboard-side-menu",
        redirectTo: "/dashboard",
        routeName: 'Dashboard'
      },
      {
        iconName: "patient-side-menu",
        redirectTo: "/patientlist",
        routeName: 'Patients'
      },
      {
        iconName: "appointment-side-menu",
        redirectTo: '/appointments',
        routeName: 'Appointments'
      },
      {
        iconName: "audit-trail-side-menu",
        redirectTo: "/invoice",
        routeName: 'Billing Invoice'
      },
      {
        iconName: "report-side-menu",
        redirectTo: "/reportlist",
        routeName: 'Reports'
      },
      {
        iconName: "user-side-menu",
        redirectTo: _routes.user.detailsWithId(storedUserId),
        routeName: 'My Profile'
      },
    ]
  }
}


// export const getActionAccordingToRole=(actions)=>{
//     const role=sessionStorage.getItem("role")
//     if(role==='Front Desk'){
//       const action = actions.filter(action => action.label === 'Preview');
//       return action
//     }
//     else{
//       return actions
//     }
//   }
